import { render, staticRenderFns } from "./CompPrivacyNotice.vue?vue&type=template&id=6a2adf27&scoped=true&"
import script from "./CompPrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./CompPrivacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./CompPrivacyNotice.vue?vue&type=style&index=0&id=6a2adf27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2adf27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCheckbox,VDialog})
